import { _ as _object_without_properties_loose, a as _extends } from './cc-CWi2JB6O.js';
import { jsx } from 'react/jsx-runtime';
import 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '@repo/lib/utils';

const buttonVariants = cva("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-5 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-1 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground shadow-xs focus-within:bg-primary/90 hover:bg-primary/90",
            destructive: "bg-destructive text-white shadow-xs focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60 focus-within:bg-destructive/90 hover:bg-destructive/90",
            outline: "border bg-background shadow-xs focus-within:bg-accent hover:bg-accent focus-within:text-accent-foreground hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:focus-within:bg-input/50 dark:hover:bg-input/50",
            secondary: "bg-secondary text-secondary-foreground shadow-xs focus-within:bg-secondary/80 hover:bg-secondary/80",
            ghost: "focus-within:bg-accent focus-within:text-accent-foreground dark:focus-within:bg-accent/50 dark:hover:bg-accent/50",
            glass: "glass before:border before:border-transparent text-white hover:bg-white/10 rounded-xl",
            link: "text-primary underline-offset-4 focus-visible:underline hover:underline",
            icon: "focus-visible:[&_svg]:fill-accent hover:[&_svg]:fill-accent focus-visible:ring-none focus-visible:ring-0 hover:ring-0"
        },
        size: {
            default: "h-9 px-4 py-2 has-[>svg]:px-3",
            sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
            lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
            xl: "h-11 rounded-lg px-8 text-lg has-[>svg]:px-4",
            "2xl": "h-11 rounded-xl px-8 text-xl has-[>svg]:px-4",
            "3xl": "h-11 rounded-2xl px-8 text-2xl has-[>svg]:px-4",
            icon: "size-9"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
function Button(_param) {
    var { className, variant, size, asChild = false } = _param, props = _object_without_properties_loose(_param, [
        "className",
        "variant",
        "size",
        "asChild"
    ]);
    const Comp = asChild ? Slot : "button";
    return /*#__PURE__*/ jsx(Comp, _extends({
        "data-slot": "button",
        className: cn(buttonVariants({
            variant,
            size,
            className
        }))
    }, props));
}

export { Button, buttonVariants };
